import axios from 'axios';
import ENV from 'environment';

export type Params = {
  type: string,
  dispatch: Function,
  url: string,
  method: 'get' | 'post',
  body?: Object,
  transform?: Object => Object,
  crunchHeaders?: Object => void,
};

export default (params: Params) => {
  const {
    type,
    dispatch,
    url,
    method,
    body,
    transform,
    crunchHeaders,
  } = params;

  return new Promise((resolve, reject) => {
    dispatch({
      type,
      meta: { done: false },
    });

    const hostUrl = `${ENV.HOST}${url}`;

    const request =
      method === 'get' ? axios[method](hostUrl) : axios[method](hostUrl, body);

    request
      .then(response => {
        const {
          data: { data: payload, result },
        } = response;

        if (result.status === 'ERR') {
          dispatch({
            type,
            payload: { message: result.message, code: result.code },
            meta: { done: true, error: true },
          });
          reject(result);
          return;
        }

        dispatch({
          type,
          payload:
            typeof transform === 'function' ? transform(payload) : payload,
          meta: { done: true },
        });

        if (!!crunchHeaders) {
          crunchHeaders(response.headers);
        }
        resolve(payload);
      })
      .catch(error => {
        dispatch({
          type,
          payload: error,
          meta: { done: true, error: true },
        });
        reject(error);
      });
  });
};



// WEBPACK FOOTER //
// ./src/utils/dispatchAsync.js